module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// ./~/duplexify/~/readable-stream/lib/internal/streams/stream-browser.js
// module id = 219
// module chunks = 0